import React from 'react'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { useFormContext } from 'react-hook-form'
import useStyles from 'pages/pga-coach/students/student-edit-page/styles'

const MedicalProfile = () => {
  const classes = useStyles()
  const { register, errors } = useFormContext()

  return (
    <FormControl className={classes.fieldGroup}>
      <Typography
        className={classes.fieldLabel}
        component="label"
        htmlFor="medicalProfileInfo"
      >
        Details
      </Typography>
      <TextField
        name="medicalProfile.info"
        id="medicalProfileInfo"
        inputRef={register}
        fullWidth
        variant="outlined"
        placeholder="Enter any allergies or medications"
        multiline
        minRows={3}
        error={!!errors.medicalProfile?.info}
        className={classes.formField}
      />
    </FormControl>
  )
}

export default MedicalProfile
